import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import { InvoiceStatus } from '../../enums/invoiceStatus'
import { QuoteStatus } from '../../enums/quoteStatus'
import { isDocumentTypeCreditNote } from '../isDocumentTypeCreditNote'
import { isInvoiceStatus } from '../isInvoiceStatus'

const getNonEligibleEInvoiceStatuses = (documentType: InvoiceDocumentType): InvoiceStatus[] => {
  const isCreditNote = isDocumentTypeCreditNote(documentType)

  if (isCreditNote) {
    return [InvoiceStatus.Deleted]
  }

  return [InvoiceStatus.Deleted, InvoiceStatus.Paid]
}

export const isEligibleEInvoiceStatus = (
  status: InvoiceStatus | QuoteStatus | undefined,
  documentType: InvoiceDocumentType,
): boolean => {
  if (!status || !isInvoiceStatus(status)) {
    return false
  }
  const isNonEligibleStatus = getNonEligibleEInvoiceStatuses(documentType).includes(status)

  return !isNonEligibleStatus
}
